module.exports = __webpack_public_path__ + "img/Ellipsedelete.b05169e3.png";